/* eslint-disable no-underscore-dangle */
import {fromJS, Set} from 'immutable';
import QuestionTypeStore from 'components/QuestionTypes/QuestionType.store';

import twoWayQuestionActions from './TwoWayQuestion.actions';

export default class TwoWayQuestionStore extends QuestionTypeStore {
  constructor(name, questionId, question) {
    super(name);

    this.initialData = fromJS({
      questionId,
      checkedColumns: [], // converted to Immutable.Set
      shouldShowExplanation: false
    });

    this.setInitialData(this.initialData);
    this.writeData('__question', question);
    this.writeData('checkedColumns', Set());
    this.handleTargeted(twoWayQuestionActions.SELECT_COLUMN, this._selectColumn);
  }

  _selectColumn(columnId) {
    const checkedColumns = this.isSelectedColumn(columnId)
      ? this.readData('checkedColumns').delete(columnId)
      : this.readData('checkedColumns').add(columnId);

    this.writeData('checkedColumns', checkedColumns);
  }

  _loadGuess(guess) {
    super._loadGuess(guess);

    const checkedColumns = Set(guess.get('content').keys());
    this.writeData('checkedColumns', checkedColumns);
  }

  _clearGuess() {
    super._clearGuess();
    this.writeData('checkedColumns', Set());
  }

  buildGuessContent() {
    const selectedOptions = this.readData('checkedColumns');
    return selectedOptions.reduce((r, optionId) => {
      r[optionId] = true;
      return r;
    }, {});
  }

  isSelectedColumn(id) {
    return this.readData('checkedColumns').includes(id);
  }
}
